import { HTMLAttributes } from 'react';

import { Spin, theme } from 'antd';
import cn from 'classnames';

import { opacityToHex } from 'shared/utils';

import styles from './OverlayLoader.module.scss';

export interface IOverlayLoaderProps extends HTMLAttributes<HTMLDivElement> {
	opacity?: number;
	zIndex?: number;
}

export const OverlayLoader = ({ className, opacity = 0.6, zIndex = 100, ...props }: IOverlayLoaderProps) => {
	const {
		token: { colorBgLayout },
	} = theme.useToken();

	return (
		<div
			{...props}
			className={cn(className, styles.overlayLoader)}
			style={{ backgroundColor: `${colorBgLayout}${opacityToHex(opacity)}`, zIndex: zIndex }}>
			<Spin size="large" />
		</div>
	);
};

export default OverlayLoader;
